import { apiHost } from '@libs/providers/api-host.provider';

export async function sendSubscribe(email: string, articleId?: string) {
    const payload = { email };

    if (articleId) {
        Object.assign(payload, { articleId });
    }

    const body = JSON.stringify(payload);
    const url = `${apiHost()}/web/subscriptions`;
    return fetch(url, {
        method: 'POST',
        body,
        headers: {
            "Content-Type": "application/json"
        }
    }).then(res => res.json());
}
